// import "./conf";
import axios from "axios";
import laGlobalProperty from "./globalProperties";
import router from '@/router'
var oproto = Object.prototype;
var serialize = oproto.toString;
var Rxports = {
    /**
     * 封装axios，减少学习成本，参数基本跟jq ajax一致
     * @param {String} type			请求的类型，默认post
     * @param {String} url				请求地址
     * @param {String} time			超时时间
     * @param {Object} data			请求参数
     * @param {String} dataType		预期服务器返回的数据类型，xml html json ...
     * @param {Object} headers			自定义请求headers
     * @param {Function} success		请求成功后，这里会有两个参数,服务器返回数据，返回状态，[data, res]
     * @param {Function} error		发送请求前
     * @param return
     */
    ajax: function (opt) {
        var opts = opt || {};
        var postData = null;
        var result = null;
        // if (!opts.url) { 	alert('请填写接口地址'); 	return false; }
        opts.data.MethodName = opts.data.ActionType;
        opts.data.AppID = laGlobalProperty.laServiceConst_AppId;
        opts.data.Parameters = opts.data.Args = JSON.stringify(opts.data.Args);
        axios.defaults.headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        };
        postData = {
            paras: opts.data //opts.data laServiceTestUrl_Interface
        };
        axios({
            method: opts.type || "post",
            url: opts.url || laGlobalProperty.laServiceUrl_Interface,
            // url: opts.url || laGlobalProperty.laServiceTestUrl_Interface,
            transformRequest: [
                function (data) {
                    data = "paras=" + JSON.stringify(opts.data);
                    return data;
                }
            ],
            data: postData || {},
            headers: opts.headers || {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            },
            // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。 它可以通过设置一个 `baseURL` 便于为 axios
            // 实例的方法传递相对 URL baseURL:'http://t.lanchenglv.com/tp5demo/index.php/',
            // timeout: opts.time || 10 * 1000,
            responseType: opts.dataType || "json"
        }).then(
            function (res) {
                if (res.status === 200) {
                    if (res.data.ErrorCode === 0) {
                        res.data.Result = JSON.parse(res.data.Result);
                        res.data.Result.Message = "成功";
                    } else if (res.data.ErrorCode === 100010) {
                        Rxports.delCookieFn("sessionid");
                        router.push('/login');
                        // location.href = "../user/login.html";
                    } else {
                        if (res.data.message) {
                            res.data.Result = res.data.message;
                        }
                    }
                    if (opts.success) {
                        opts.success(res.data);
                    }
                } else {
                    if (data.error) {
                        opts.error(error);
                    } else {
                        alert("服务器繁忙");
                    }
                }
            },
            function (error) {
                if (opts.error) {
                    opts.error(error);
                } else {
                    // var txt=  "服务器繁忙，请销后再试";
                    // window.wxc.xcConfirm("txt", window.wxc.xcConfirm.typeEnum.error);
                    alert("服务器繁忙");
                }
            }
        );
        // .catch(function(error) {
        //   // console.log(error);
        //   if (opts.error) {
        //     opts.error(error);
        //   } else {
        //     // var txt=  "服务器繁忙，请销后再试";
        //     // window.wxc.xcConfirm("txt", window.wxc.xcConfirm.typeEnum.error);
        //     alert("好多人在访问呀，请重新试试[timeout]");
        //   }
        // });
    },
    mockAjax: function (obj) {
        // 0是yapi 1不是
        if (obj.type === 0) {
            var url = "http://10.1.128.11:3000/mock/11" + obj.url;
            var params = { params: obj.params }
        } else {
            var url = 'api' + obj.url;
            var params = obj.params;
        }
        return new Promise((resolve, reject) => {
            axios.post(url, params).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    /*判定是否类数组，如节点集合，纯数组，arguments与拥有非负整数的length属性的纯JS对象*/
    isArrayLike: function (obj) {
        if (!obj) return false;
        var n = obj.length;
        if (n === n >>> 0) {
            //检测length属性是否为非负整数
            var type = serialize.call(obj).slice(8, -1);
            if (/(?:regexp|string|function|window|global)$/i.test(type)) return false;
            if (type === "Array") return true;
            try {
                if ({}.propertyIsEnumerable.call(obj, "length") === false) {
                    //如果是原生对象
                    return /^\s?function/.test(obj.item || obj.callee);
                }
                return true;
            } catch (e) {
                //IE的NodeList直接抛错
                return !obj.window; //IE6-8 window
            }
        }
        return false;
    },
    /*遍历数组与对象,回调的第一个参数为索引或键名,第二个或元素或键值*/
    each: function (obj, fn) {
        var That = this;
        if (obj) {
            //排除null, undefined
            var i = 0;
            if (That.isArrayLike(obj)) {
                for (var n = obj.length; i < n; i++) {
                    if (fn(i, obj[i]) === false) break;
                }
            } else {
                for (i in obj) {
                    if (obj.hasOwnProperty(i) && fn(i, obj[i]) === false) {
                        break;
                    }
                }
            }
        }
    },
    /**
     * 获取url传过来的参数
     * @param name 	获取的参数
     * @param Url 		自定义获取参数的链接
     * @param return
     */
    getUrlQuery: function (name, Url) {
        //URL GET 获取值
        var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i"),
            url = Url || location.href;
        if (reg.test(url)) return decodeURI(RegExp.$2.replace(/\+/g, " "));
        return "";
    },
    /**
     * 补零
     * @param str 	获取的参数
     * @param n 	补零的长度
     * @param return
     */
    padString: function (str, n) {
        var len = str.length;
        while (len < n) {
            str = "0" + str;
            len++;
        }
        return str;
    },
    /**
     * 获取星期几
     * @param str 	获取的参数
     * @param n 	补零的长度
     * @param return
     */
    getWeekName: function (inDate) {

        var week;
        if (inDate.getDay() == 0) week = "周日";
        if (inDate.getDay() == 1) week = "周一";
        if (inDate.getDay() == 2) week = "周二";
        if (inDate.getDay() == 3) week = "周三";
        if (inDate.getDay() == 4) week = "周四";
        if (inDate.getDay() == 5) week = "周五";
        if (inDate.getDay() == 6) week = "周六";

        return week;
    },
    /**
     * 时间格式化
     * @param str 	获取的参数
     * @param n 	补零的长度
     * @param return
     */
    formatDate: function (date, fmt) {
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        let o = {
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds()
        };
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + "";
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length));
            }
        }
        return fmt;
    },
    dateFormat: function (input, isM) {
        var d = new Date(input);
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var hour = d.getHours();
        var minutes = d.getMinutes();
        var seconds = d.getSeconds();
        if (!isM) {
            day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
            month = month < 10 ? '0' + month : month;

        } else if (isM == 's') {

        } else if (isM == 'gets') {
            day = day < 10 ? '0' + day : day;
            month = month < 10 ? '0' + month : month;
            hour = hour < 10 ? '0' + hour : hour;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
        }
        return year + '-' + month + '-' + day
        //+ ' ' + hour + ':' + minutes + ':' + seconds;
    },
    dateFormatT: function (inputDate) {
        let d = '';
        if (typeof inputDate == 'number') {
            d = new Date(inputDate);
        } else {
            d = new Date(inputDate.replace('T', ' ').replace(/-/g, "/"))
        }
        return d;
    },
    /**
     * 引用类型深拷贝
     * @param obj 	入参
     * @param return
     */
    deepCope: function (obj) {
        var newObj = {};
        for (var key in obj) {
            //只赋值对象自己的属性，原型上的属性不赋值
            if (obj.hasOwnProperty(key)) {
                //obj.hasOwnProperty(prop)这个方法可以用来检测一个对象是否含有特定的自身属性
                if (typeof obj[key] === "number" || typeof obj[key] === "string" || typeof obj[key] === "undefined" || typeof obj[key] === "boolean" || obj[key] === null) {
                    //由于typeof null返回值也是object，所以不能直接用typeof obj[key] === 'object'来判断
                    newObj[key] = obj[key];
                } else {
                    newObj[key] = Rxports.deepCope(obj[key]); //递归
                }
            }
            return newObj;
        }
    },
    objDeepCopy: function (source) {
        var sourceCopy = source instanceof Array ? [] : {};
        for (var item in source) {
            sourceCopy[item] = typeof source[item] === "object" ? Rxports.objDeepCopy(source[item]) : source[item];
        }
        return sourceCopy;
    },
    //参数处理
    escapeQuery: function (str) {
        //参数处理
        if (!str) {
            return "";
        }
        var _isObj = false;
        if (typeof str != "string") {
            try {
                str = JSON.stringify(str);
                _isObj = true;
            } catch (e) { }
        }
        var obj = {
            "<": "&lt;",
            ">": "&gt;"
        };
        str = str.replace(/(\<|\>)/gi, function (s, t) {
            return obj[t];
        });
        if (_isObj) {
            try {
                str = JSON.parse(str);
            } catch (e) { }
        }
        return str;
    },
    hump: function (str) {
        //驼峰转下划线小写
        if (typeof str === "string" && str !== "") {
            return str.replace(/([^_])([A-Z])/g, "$1_$2").toLocaleLowerCase();
        }
        return str;
    },
    //设置cookie
    setCookie: function (name, value, time) {
        var _name = Rxports.hump(name),
            _value = Rxports.escapeQuery(value);
        var _time = time ? time : "d" + 30;

        function getsec(str) {
            var str1 = str.substring(1, str.length) * 1;
            var str2 = str.substring(0, 1);
            if (str2 == "s") {
                return str1 * 1000;
            } else if (str2 == "h") {
                return str1 * 60 * 60 * 1000;
            } else if (str2 == "d") {
                return str1 * 24 * 60 * 60 * 1000;
            } else if (str2 == "y") {
                return str1 * 365 * 12 * 24 * 60 * 60 * 1000;
            }
        }
        // var domain = conf.cookieDomain;
        var domain = location.hostname;
        var strsec = getsec(_time);
        var exp = new Date();
        exp.setTime(exp.getTime() + strsec * 1);
        document.cookie = encodeURIComponent(String(_name)) + "=" + encodeURIComponent(String(value)) + (exp.toUTCString() != null ? "; expires=" + exp.toUTCString() : "") + "; path=/" + ("; domain=" + domain);
    },
    //获取cookie
    getCookie: function (name) {
        name = name || "";
        name = Rxports.hump(name);
        var arr,
            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if ((arr = document.cookie.match(reg))) return decodeURIComponent(arr[2]);
        else return null;
    },
    //删除cookie
    delCookieFn: function (name) {
        name = name || "";
        name = Rxports.hump(name);
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = Rxports.getCookie(name);
        if (cval != null) {
            var domain = location.hostname;
            //document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
            document.cookie = name + "=" + 0 + "; expires=" + exp.toUTCString() + "; path=/" + ("; domain=" + domain);
        }
    },
    // 获取localstore
    getLocalstorage: function (paramstr) {
        if (localStorage.getItem(paramstr) && localStorage.getItem(paramstr) != 'undefined') {
            return localStorage.getItem(paramstr)
        } else {
            return ''
        }
    },
    //转化时间
    getNowFormatDate: function (date) {
        var date = date ? new Date(date) : new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    //base64编码
    encode: function (str) {
        var c1, c2, c3;
        var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var i = 0,
            len = str.length,
            string = "";

        while (i < len) {
            c1 = str.charCodeAt(i++) & 0xff;
            if (i == len) {
                string += base64EncodeChars.charAt(c1 >> 2);
                string += base64EncodeChars.charAt((c1 & 0x3) << 4);
                string += "==";
                break;
            }
            c2 = str.charCodeAt(i++);
            if (i == len) {
                string += base64EncodeChars.charAt(c1 >> 2);
                string += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
                string += base64EncodeChars.charAt((c2 & 0xf) << 2);
                string += "=";
                break;
            }
            c3 = str.charCodeAt(i++);
            string += base64EncodeChars.charAt(c1 >> 2);
            string += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
            string += base64EncodeChars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
            string += base64EncodeChars.charAt(c3 & 0x3f);
        }
        return string;
    },
    //base64解码
    decode: function (str) {
        var c1, c2, c3, c4;
        var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
            62, -1, -1, -1,
            63,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61, -1, -1, -1, -1, -1, -1, -1,
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25, -1, -1, -1, -1, -1, -1,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51, -1, -1, -1, -1, -1
        );
        var i = 0,
            len = str.length,
            string = "";

        while (i < len) {
            do {
                c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
            } while (i < len && c1 == -1);

            if (c1 == -1) break;

            do {
                c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
            } while (i < len && c2 == -1);

            if (c2 == -1) break;

            string += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

            do {
                c3 = str.charCodeAt(i++) & 0xff;
                if (c3 == 61) return string;

                c3 = base64DecodeChars[c3];
            } while (i < len && c3 == -1);

            if (c3 == -1) break;

            string += String.fromCharCode(((c2 & 0xf) << 4) | ((c3 & 0x3c) >> 2));

            do {
                c4 = str.charCodeAt(i++) & 0xff;
                if (c4 == 61) return string;
                c4 = base64DecodeChars[c4];
            } while (i < len && c4 == -1);

            if (c4 == -1) break;

            string += String.fromCharCode(((c3 & 0x03) << 6) | c4);
        }
        return string;
    },
    //获取证件类型的枚举
    getFoidType(status) {
        switch (status) {
            case "身份证":
              return 1;
            case "护照":
              return 2;
            case "台胞证":
              return 3;
            case "港澳通行证":
              return 4;
            case "外国人永久居留身份证":
              return 6;
            case "港澳台居民居住证":
              return 11;
            case "户口簿":
              return 21;
            case "回乡证":
              return 22;
            case "海员证":
              return 25;
            case "外国人出入境证":
              return 32;  
            case "其他":
              return 100;
        }
    },
    // 封装alert 弹窗

    alertTip: function (text) {
        var MBox = document.createElement('div');
        $(MBox).attr("class", "alert_teamljj_box");
        $('#app').append(MBox);
        $(MBox).html(text);
        setTimeout(function () {
            $(MBox).hide();
        }, 3000)
    },
    getDiscount: function (num) {
        var str = num.toString().split('.');
        if (str.length == 2) {
            var length = str[1].length;
            return Math.round(num * Math.pow(10, length)) / Math.pow(10, length - 1);
        } else if (str.length == 1) {
            return str * 10;
        } else {
            return false;
        }
    },
    // 处理时间
    handleTime(val) {
        var date = new Date(val.replace("T", " ").replace(/-/g, "/"));
        let Y = date.getFullYear();
        let M =
            date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1;
        let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        val = Y + "-" + M + "-" + D;
        return val;
    },
    getTimeKey(val) {
        if (val) {
            var date = new Date(val);
            let Y = date.getFullYear();
            let M =
                date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1;
            let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            val = Y + "-" + M + "-" + D + 'T00:00:00';
            return val;
        }
    },
    // 获取日历七天列表
    getCalener(date) {
        let dateArr = [];
        if (date) {
            date = date + ' ' + '00:00:00';
            date = date.replace(/-/g, '/');
            date = new Date(date).getTime();
            for (let i = -3; i < 3; i++) {
                let obj = {
                    time: date + (24 * 3600 * 1000) * i,
                    isSelect: i == 0 ? true : false,
                    key: Rxports.getTimeKey(date + (24 * 3600 * 1000) * i)
                }
                dateArr.push(obj)
            }
        }
        return dateArr;
    },
    // 将日期转时间戳
    unTimeStampInit(day) {
        let time = '';
        if (day) {
            day = day.replace('T', ' ').replace(/-/g, '/');
            let Y = new Date(day).getFullYear();
            let M = new Date(day).getMonth() + 1 >= 10 ? new Date(day).getMonth() + 1 : "0" + (new Date(day).getMonth() + 1);
            let D = new Date(day).getDate() >= 10 ? new Date(day).getDate() : "0" + new Date(day).getDate();
            time = new Date(Y + "/" + M + "/" + D + " " + "00:00:00").getTime();
        }
        return time;
    },
    getChineseStringCnt(v) {
        var sum = 0;
        for (var i = 0; i < v.length; i++) {
            var c = v.charCodeAt(i);
            if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) { } else {
                sum++;
            }
        }
        return sum;
    },
    getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURIComponent(r[2]);
        return null;
    },
    // /**
    //  * 云商城商品列表地址拼接
    //  * @param goodsId 商品id
    //  * @param channel 渠道类型
    //  * @param type 	  商品类型
    //  * @param return  正式地址/测试地址
    //  */
    // getMallUrl: function (goodsId,channel,type) {
    //     var week;
    //     if (inDate.getDay() == 0) week = "周日";
    //     if (inDate.getDay() == 1) week = "周一";
    //     if (inDate.getDay() == 2) week = "周二";
    //     if (inDate.getDay() == 3) week = "周三";
    //     if (inDate.getDay() == 4) week = "周四";
    //     if (inDate.getDay() == 5) week = "周五";
    //     if (inDate.getDay() == 6) week = "周六";
    //     return week;
    // },
};

export default Rxports;


// WEBPACK FOOTER //
// ./src/assets/js/common.js